import React from "react";
import { useTranslation } from "react-i18next";
import { SOCIAL } from "../../utils/constants";
import parse from "html-react-parser";
import { useNavigation, openLinkInNewTab } from "../../utils/functions";
import "./styles.css";

const Headline = () => {
  const { t } = useTranslation();
  return (
    <div className="footer-mission-headline-container">
      <span className="footer-mission-headline-ideas">
        {t("landingPage.footer.mission.headlineChangeIdeas")}
      </span>
      <div className="footer-mission-headline-sepator" />
      <span className="footer-mission-headline-goal">
        {parse(t("landingPage.footer.mission.headlineGoal"))}
      </span>
    </div>
  );
};

const Button = ({ route, url, className, label }) => {
  const { t } = useTranslation();
  const goTo = useNavigation();
  return (
    <div onClick={() => (route ? goTo(route) : openLinkInNewTab(url))} className={className}>
      {t(label)}
    </div>
  );
};

const MissionFooter = () => {
  const { t } = useTranslation();
  return (
    <div className="footer-mission-background">
      <div className="footer-mission-container">
        <Headline />
        <span className="footer-mission-about">{parse(t("landingPage.footer.mission.about"))}</span>
        <div className="footer-mission-button-container">
          <Button
            url={SOCIAL.whatsapp}
            className="footer-mission-button-contact common-button"
            label="landingPage.footer.mission.buttons.contact"
          />
          <Button
            url={SOCIAL.instagram}
            className="footer-mission-button-about common-button"
            label="landingPage.footer.mission.buttons.about"
          />
        </div>
      </div>
    </div>
  );
};

export default MissionFooter;
